import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { customAxios } from "lib/axios";

type RegisterClientInput = {
  name: string;
  email: string;
  phone: string;
  address: string;
  notes?: string;
  managedBy: string;
  description?: string;
};

type Client = {
  _id: string;
  name: string;
  email: string;
  phone: string;
  address: string;
  notes?: string;
  description?: string;
  org: string;
  managedBy: string;
  createdAt: string;
  updatedAt: string;
};

type RegisterClientResponse = {
  success: boolean;
  client: Client;
};

const registerClient = async (
  clientData: RegisterClientInput
): Promise<RegisterClientResponse> => {
  const response: AxiosResponse<RegisterClientResponse> =
    await customAxios.post("/client", clientData);
  return response.data;
};

export const useCreateClient = () => {
  const queryClient = useQueryClient();

  const registerClientMutation = useMutation<
    RegisterClientResponse,
    Error,
    RegisterClientInput
  >({
    mutationFn: registerClient,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["clients"] });
    },
  });

  return {
    registerClient: registerClientMutation.mutate,
    isRegisteringClient: registerClientMutation.isLoading,
  };
};
